import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';

@Component({
  selector: 'number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent implements OnInit {
  formGroup: UntypedFormGroup;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public initValue: number;
  @Input()
  public placeholder = 'Nummer';
  @Input()
  public disabled = false;

  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initInputForm();
    if (this.disabled) {
      this.formGroup.get('answer').disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.formGroup == null) {
      return;
    }
    if (changes.disabled) {
      if (changes.disabled.currentValue === true) {
        this.formGroup.get('answer').disable();
      } else if (changes.disabled.currentValue === false) {
        this.formGroup.get('answer').enable();
      }
    }
    if (changes.initValue) {
      this.formGroup.get('answer').setValue(changes.initValue.currentValue);
    }
  }

  initInputForm(): UntypedFormGroup {
    return this.formBuilder.group({
      answer: new UntypedFormControl(this.initValue)
    });
  }

  answered() {
    this.answer.emit(this.formGroup.get('answer').value);
  }
}
